import {setTitle} from "@src/util";

export default function (props: { time: string }) {
	const {time} = props;
	console.log(time)
	setTitle('温馨提示')
	return <div className="holiday">
	<p style={{fontSize: 16}}>各位车友：</p>
	<p style={{textIndent: '2em'}}>因春节放假，我司将于2025年1月24日下午5点起暂停业务办理，于2025年2月5日上午10点恢复业务办理，祝您春节愉快!</p>
</div>
}